<div class="row">
  <div class="col-md-4">
    <div class="card">
      <form class="form-horizontal" #truckInformation="ngForm">
        <div class="card-body">
          <div class="form-group row">
            <div class="col-md-12 col-sm-12 col-sx-12" style="direction: rtl">
              <app-material-number-plate
                id="truckNumber"
                [registrationNumber]="(selectedTruck?.truckNumber)"
                (registrationNumberUpdated)="selectedTruck.truckNumber = $event"
                [disabled]="edit"
                tabindex="1">
              </app-material-number-plate>
            </div>
          </div>
            <div class="form-group row">
              <app-material-pg-input
                label="VIN"
                type="text"
                name="VIN"
                id="VIN"
                [ngModel]="selectedTruck?.VIN"
                (ngModelChange)="selectedTruck.VIN = $event"
                tabindex="2"
                [required]="true"
                [disabled]="edit">
              </app-material-pg-input>
          </div>
          <div class="form-group row">
              <app-material-organisation-selector
                name="organisationId"
                id="organisationId"
                [placeholder]=" 'شرکت دارنده کشنده '"
                [organisations]="organisations"
                [(ngModel)]="transporter"
                (ngModelChange)="notUsedTankers()"
                [organisationLanguage]="'fa'"
                tabindex="3"
                [required]="true"
                [disabled]="editableField !== 'transporter' && edit">
              </app-material-organisation-selector>
          </div>
          <div class="form-group row">
              <app-material-auto-complete
                [formatter]="tankerValueFormatter"
                [(ngModel)]="tanker"
                [items]="tankersList"
                name="tanker"
                [placeholder]="'شماره تانکر '"
                [disabled]="editableField !== 'tanker' && edit">
              </app-material-auto-complete>
          </div>
          <div class="form-group row">
            <app-material-pg-input
                label="نام راننده "
                type="text"
                name="driverName"
                id="driverName"
                [(ngModel)]="driver.name"
                tabindex="6"
                [disabled]="editableField !== 'driver' && edit"
                [required]="true">
              </app-material-pg-input>
          </div>
          <div class="form-group row">
              <app-material-auto-complete
                [formatter]="trackerValueFormatter"
                [(ngModel)]="tracker"
                [items]="trackersList"
                id="tracker"
                name="tracker"
                [placeholder]="' شماره دستگاه ردیاب'"
                [disabled]="editableField !== 'tracker' && edit">
              </app-material-auto-complete>
          </div>
          <div class="form-group row">
            <app-material-chunk-file-uploader
              [accept]="'.pdf, .jpg'"
              name="document"
              [ngModel]="document"
              (ngModelChange)="uploadDocument($event)"
              [disabled]="editableField !== 'file' && edit">
            </app-material-chunk-file-uploader>
          </div>
          <div class="form-group row">
            <label for="isActive" class="col-form-label col-md-4 ">فعال</label>
            <mat-checkbox
              class=" col-md-4 "
              type="checkbox"
              id="isActive"
              name="isActive"
              [ngModel]="selectedTruck?.active"
              (ngModelChange)="selectedTruck.active = $event"
              tabindex="9"
              [disabled]="editableField === 'information'">
            </mat-checkbox>
          </div>
          <div class="form-group row">
            <label for="isDeleted" class="col-form-label col-md-4 ">
              حذف شده</label>
              <mat-checkbox
                class=" col-md-4 "
                type="checkbox"
                id="isDeleted"
                name="isDeleted"
                [ngModel]="selectedTruck?.isDeleted"
                (ngModelChange)="selectedTruck.isDeleted = $event"
                [disabled]="editableField === 'information'">
              </mat-checkbox>
          </div>
          <div class="form-group row">
            <div>
              <app-material-pg-button
                class=" pull-right"
                (clicked)="add()"
                [disabled]="editableField === 'information' && !truckInformation.form.valid"
                label="save"
                tabindex="15">
              </app-material-pg-button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="card card-body">
      <div class="col-md-12">
        <table
          class="table table-sm table-striped table-bordered">
          <thead>
            <tr>
              <th>نوع</th>
              <th>شناسه</th>
              <th>تاریخ شروع</th>
              <th>تاریخ پایان</th>
            </tr>
          </thead>
          <tbody>
            @for (object of associatedObjectList; track $index) {
              <tr>
                <td>{{object.type}}</td>
                <td>{{object.objectId}}</td>
                <td>{{object.startTime}}</td>
                <td>{{object.endTime}}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
  @if (selectedTruck && selectedTruck.fileId) {
    <div class="col-md-4">
      <app-material-pdf-viewer [fileId]="selectedTruck.fileId"></app-material-pdf-viewer>
    </div>
  }
  @if (tanker && tanker.fileId) {
    <div class="col-md-4">
      <app-material-pdf-viewer [fileId]="tanker.fileId"></app-material-pdf-viewer>
    </div>
  }
</div>
